// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Modal0 from "../common/Modal0.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Search2 from "../common/Search2.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as SearchField2 from "../components/SearchField2.bs.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

var augmentsGrid = "grid grid-cols-[repeat(7,90px)] gap-[6px] gap-y-[14px] pb-12";

var Styles = {
  augmentsGrid: augmentsGrid
};

function TbAugmentsModal14$Cell(Props) {
  var id = Props.id;
  var onSelectAugment = Props.onSelectAugment;
  var t = Translation.useT(/* Augments */4);
  return React.createElement("div", {
              className: "flex flex-col items-center cursor-pointer",
              onClick: (function (param) {
                  return Curry._1(onSelectAugment, id);
                })
            }, React.createElement(AugmentImage.make, {
                  augId: id,
                  size: 50
                }), React.createElement("div", {
                  className: "text-xs leading-tight text-center pt-[6px]"
                }, t(id)));
}

var Cell = {
  make: TbAugmentsModal14$Cell
};

function TbAugmentsModal14(Props) {
  var modalOpen = Props.modalOpen;
  var setModalOpen = Props.setModalOpen;
  var augments = Props.augments;
  var onSelectAugment = Props.onSelectAugment;
  var set = TftSet.use(undefined);
  Translation.useT(/* Units */1);
  Translation.useT(/* Augments */4);
  Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return "";
      });
  var search = match[0];
  var match$1 = React.useState(function () {
        return /* Augs */0;
      });
  var allAugments = React.useMemo((function () {
          return Belt_Array.keep(Js_dict.entries(Data.augments(set)), (function (param) {
                        return param[1].id >= 0;
                      }));
        }), []);
  var searchIds = React.useMemo((function () {
          if (search === "") {
            return ;
          } else {
            return Belt_SetString.fromArray(Search2.searchAugmentsArr(search, set));
          }
        }), [search]);
  var data = React.useMemo((function () {
          return Belt_Array.map(Belt_SortArray.stableSortBy(allAugments, (function (param, param$1) {
                            return Caml.caml_string_compare(param[1].name, param$1[1].name);
                          })), (function (param) {
                        return [
                                param[0],
                                param[1]
                              ];
                      }));
        }), []);
  return React.createElement(Modal0.make, {
              opened: modalOpen,
              onClose: (function (param) {
                  return Curry._1(setModalOpen, (function (param) {
                                return false;
                              }));
                }),
              children: null,
              modalClass: "w-[700px] p-4 sm:p-5"
            }, React.createElement("div", {
                  className: "flex justify-between items-center pl-2 pb-6"
                }, React.createElement(SearchField2.make, {
                      search: search,
                      setSearch: match[1]
                    })), match$1[0] === /* Augs */0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: augmentsGrid
                      }, Belt_Array.map(Belt_Array.keep(Belt_Array.keep(Belt_Array.keep(data, (function (param) {
                                          var augment = param[1];
                                          if (augment.rank === 1) {
                                            return Belt_Option.isNone(augment.hero);
                                          } else {
                                            return false;
                                          }
                                        })), (function (param) {
                                      if (search === "") {
                                        return true;
                                      } else {
                                        return Belt_SetString.has(searchIds, param[0]);
                                      }
                                    })), (function (param) {
                                  return !augments.includes(param[0]);
                                })), (function (param) {
                              var id = param[0];
                              return React.createElement(TbAugmentsModal14$Cell, {
                                          id: id,
                                          onSelectAugment: onSelectAugment,
                                          key: id
                                        });
                            }))), React.createElement("div", {
                        className: augmentsGrid
                      }, Belt_Array.map(Belt_Array.keep(Belt_Array.keep(Belt_Array.keep(data, (function (param) {
                                          return param[1].rank === 2;
                                        })), (function (param) {
                                      if (search === "") {
                                        return true;
                                      } else {
                                        return Belt_SetString.has(searchIds, param[0]);
                                      }
                                    })), (function (param) {
                                  return !augments.includes(param[0]);
                                })), (function (param) {
                              var id = param[0];
                              return React.createElement(TbAugmentsModal14$Cell, {
                                          id: id,
                                          onSelectAugment: onSelectAugment,
                                          key: id
                                        });
                            }))), React.createElement("div", {
                        className: augmentsGrid
                      }, Belt_Array.map(Belt_Array.keep(Belt_Array.keep(Belt_Array.keep(data, (function (param) {
                                          return param[1].rank === 3;
                                        })), (function (param) {
                                      if (search === "") {
                                        return true;
                                      } else {
                                        return Belt_SetString.has(searchIds, param[0]);
                                      }
                                    })), (function (param) {
                                  return !augments.includes(param[0]);
                                })), (function (param) {
                              var id = param[0];
                              return React.createElement(TbAugmentsModal14$Cell, {
                                          id: id,
                                          onSelectAugment: onSelectAugment,
                                          key: id
                                        });
                            }))), search !== "" && Belt_SetString.size(searchIds) === 0 ? React.createElement("div", {
                          className: "text-2xl font-montserrat font-medium w-full text-center"
                        }, "No augments matching the search") : null) : React.createElement("div", {
                    className: "flex flex-wrap gap-4"
                  }));
}

var make = TbAugmentsModal14;

export {
  Styles ,
  Cell ,
  make ,
  
}
/* Data Not a pure module */
